import Bodytitle from "./bodycourse";
import Allcourse from "./courses";
import HCarousel from "./headercaurocal";
import Navbar1 from "./navbar";
import './index.css';
import Footermuft from "./footer";

function Home() {
    return (
        <div>
            <div>
                <Navbar1 />
            </div>
            <div>
                <HCarousel />
            </div>
            <div>
                <Bodytitle/>
            </div>
            <div>
                <Allcourse />
            </div>
            <div>
                <Footermuft/>
            </div>
        </div>
    );
}

export default Home;